import { RouterStore } from "mobx-react-router";
const routingStore = new RouterStore();
export default routingStore;